import React from 'react'

import { CodigosTransaccionesConstant } from 'constants/index'

import { Portlet } from '_zari/core'

import * as Sections from './sections'

const portletBreadcrumbs = [{ name: 'Usuarios', path: `/${CodigosTransaccionesConstant.USUARIOS_LISTA}` }, { name: 'Firmas de usuario' }]

const FirmasUsuarioPage = ({ match }) => {
  const username = React.useMemo(() => {
    return match.params.id
  }, [match])

  return (
    <>
      <Portlet>
        <Portlet.Header title='' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Sections.InfoUsuarioSection username={username} />
          <Sections.TablaFirmasSection username={username} />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default FirmasUsuarioPage
